import {
    AssessmentSchedule,
    Contact
} from "../../models";
import {
    Box,
    Typography
} from "@mui/material";
import {
    Location,
    ResourceNotificationSetting,
} from "../../API";

import { AssessmentScheduleDropDownMenu } from "./AssessmentScheduleDropDownMenu";
import { ExpandableDisplayText } from "./ExpandableDisplayText";
import React from "react";
import { scheduleToHumanReadableConverter } from "./scheduleToHumanReadableConverter";

type AssessmentScheduleListItemProps = {
    assessmentSchedule: AssessmentSchedule;
    missedNotificationSetting?: ResourceNotificationSetting;
    associatedLocations: Array<Location>;
    contacts: Array<Contact>;
    setIsOpenCreateContactDialog: React.Dispatch<React.SetStateAction<boolean>>;
};

export const AssessmentScheduleListItem = (props: AssessmentScheduleListItemProps) => {
    const {
        assessmentSchedule,
        associatedLocations,
        contacts,
        setIsOpenCreateContactDialog,
        missedNotificationSetting
    } = props;

    return (
        <Box display="grid" gridTemplateColumns="1fr auto" gap={1}>
            <Box display="flex" flexDirection="column" gap={0.25} minWidth={0}>
                <ExpandableDisplayText
                    linesToDisplayWhenCollapsed={1}
                    description={assessmentSchedule.name || ""}
                    typographyProps={{ variant: "h6" }}
                />
                {assessmentSchedule.description && (
                    <ExpandableDisplayText
                        linesToDisplayWhenCollapsed={1}
                        description={assessmentSchedule.description}
                    />
                )}
                <Typography>Locations: {associatedLocations.map(location => location.name).join(", ")}</Typography>
                <Typography>Recurrence: {scheduleToHumanReadableConverter.convert(assessmentSchedule)}</Typography>
            </Box>
            <AssessmentScheduleDropDownMenu
                assessmentSchedule={assessmentSchedule}
                missedNotificationSetting={missedNotificationSetting}
                associatedLocations={associatedLocations}
                contacts={contacts}
                setIsOpenCreateContactDialog={setIsOpenCreateContactDialog}
            />
        </Box>
    );
};